import { useContext, useState } from 'react';
import { Button } from 'semantic-ui-react';
import { DashboardProfileComponent } from './styles/DashboardProfileComponent';
import { GuestDashboardContext } from './guestDashboardContext';
import EditGuestProfileModal from './EditGuestProfileModal';
import { getGuest } from './guestDashboardApiCalls';

const shouldOpenEditFromQuery = () => {
  const edit = new URLSearchParams(window.location.search).get('edit');
  return edit === '1' || edit === 'true';
};

const displayValue = (value) => {
  if (value == null || String(value).trim() === '') return '—';
  return value;
};

const ProfileFact = ({ label, value }) => (
  <div className="profile-fact">
    <dt>{label}</dt>
    <dd>{displayValue(value)}</dd>
  </div>
);

const Profile = () => {
  const [editOpen, set_editOpen] = useState(shouldOpenEditFromQuery);
  const { guest, setGuest, setLoginCredentials } = useContext(GuestDashboardContext);
  const fullName = [guest?.name, guest?.lastName].filter(Boolean).join(' ');
  const leaderName = guest?.GuestLeader?.leaderFullName;
  const leaderPhone = guest?.GuestLeader?.leaderPhone;

  return (
    <DashboardProfileComponent>
      <div className="profile-header">
        <p className="greeting">Hola, {guest.name}!</p>
        <h2 className="profile-title">
          Estos son tus <span className="profile-text">datos</span>
        </h2>
      </div>

      <div className="profile-details-scroll">
        <article className="profile-card">
          <div className="profile-identity">
            <div className="profile-avatar">
              {guest?.photo ? (
                <img src={guest.photo} alt="" className="profile-display-image" />
              ) : (
                <div className="profile-display-placeholder">Sin foto</div>
              )}
            </div>
            <div className="profile-identity-copy">
              <h3 className="profile-name">{fullName || '—'}</h3>
              <p className="profile-id">ID {displayValue(guest.identification)}</p>
              <Button
                primary
                className="edit-profile-open"
                type="button"
                onClick={() => set_editOpen(true)}
              >
                Actualizar mis datos
              </Button>
            </div>
          </div>

          <dl className="profile-facts">
            <ProfileFact label="Correo electrónico" value={guest.email} />
            <ProfileFact label="Teléfono" value={guest.phone} />
            <ProfileFact label="Género" value={guest.gender} />
            <ProfileFact label="Estado civil" value={guest.civil} />
            <ProfileFact label="Cumpleaños" value={guest.birthdate} />
            {(leaderName || leaderPhone) && (
              <>
                <ProfileFact label="Líder" value={leaderName} />
                <ProfileFact label="Teléfono del líder" value={leaderPhone} />
              </>
            )}
          </dl>
        </article>
      </div>

      <EditGuestProfileModal
        open={editOpen}
        onClose={() => set_editOpen(false)}
        guest={guest}
        onUpdated={async ({ identification, phone }) => {
          const found = await getGuest({ identification, phone, setGuest });
          if (found) setLoginCredentials({ identification, phone });
        }}
      />
    </DashboardProfileComponent>
  );
};

export default Profile;
